module.exports = __webpack_public_path__ + "static/media/16.160e908a.jpg";